import React, { useEffect, useRef, useState } from 'react'

const getDropboxThumbnail = async (accessToken, pathLower) => {
  const { Dropbox } = window.Dropbox
  const dbx = new Dropbox({ accessToken })

  try {
    const res = await dbx.filesGetThumbnailV2({
      resource: { '.tag': 'path', path: pathLower },
      format: { '.tag': 'png' },
      mode: { '.tag': 'strict' },
      size: { '.tag': 'w64h64' }
    })

    return URL.createObjectURL(res.result.fileBlob)
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('No thumbnail available for', pathLower)
    return null
  }
}

const useLazyThumbnail = (accessToken, file) => {
  const [thumbnail, setThumbnail] = useState(null)
  const ref = useRef(null)

  useEffect(() => {
    let isMounted = true // Track mount state

    const observer = new IntersectionObserver(
      async ([entry]) => {
        if (entry.isIntersecting && !thumbnail) {
          const thumb = await getDropboxThumbnail(accessToken, file.path_lower)
          if (thumb && isMounted) setThumbnail(thumb) // Only update if mounted
        }
      },
      { rootMargin: '50px' }
    )

    if (ref.current) observer.observe(ref.current)

    return () => {
      isMounted = false
      observer.disconnect()
    }
  }, [accessToken, file, thumbnail])

  return [thumbnail, ref]
}

const FileItem = ({ file, accessToken, onOpen }) => {
  const [thumbnail, ref] = useLazyThumbnail(accessToken, file)
  const isFolder = file['.tag'] === 'folder'

  return (
    <div
      className="file-item mt-3"
      ref={ref}
      onClick={() => onOpen(file)}
      style={{
        opacity: file.disabled ? 0.5 : 1,
        pointerEvents: file.disabled ? 'none' : 'auto'
      }}
    >
      {isFolder ? (
        <img src={'/assets/icons/folder-fill.svg'} alt={'folder'} className="file-thumb" />
      ) : thumbnail ? (
        <img src={thumbnail} alt={file.name} className="file-thumb" />
      ) : (
        <img src={'/assets/icons/file-earmark.svg'} alt={'file'} className="file-thumb" />
      )}
      <span className="file-name">{file.name}</span>
    </div>
  )
}

export default FileItem
